(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[32],{

/***/ "Gh9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL; });
var TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL = {
  actionGA: 'activities',
  labelGA: 'chooseSkiEquipment',
  versionBooking: 'responsive'
};

/***/ }),

/***/ "Iev9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAuthentication; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ub5k");


function useAuthentication() {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"]);
  return {
    isLogged: appContext.isUserLogged,
    isQuickLogged: appContext.isUserQuickLogged
  };
}

/***/ }),

/***/ "NRmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return TRACK_PAGELOAD_EVENT_CA_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return TRACK_PAGELOAD_EVENT_CA_ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return TRACK_PAGELOAD_ERROR_EVENT_CA_ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nb", function() { return TRACK_PAGELOAD_SUCCESS_EVENT_CA_ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return TRACK_PAGELOAD_EVENT_CA_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return TRACK_PAGELOAD_EVENT_CA_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kb", function() { return TRACK_PAGELOAD_EVENT_CA_RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lb", function() { return TRACK_PAGELOAD_EVENT_CA_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mb", function() { return TRACK_PAGELOAD_EVENT_CA_TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return TRACK_FRAG_CA_INFOBANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRACK_CLICK_EVENT_CA_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TRACK_CLICK_EVENT_CA_PREBOOKING_ACCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRACK_CLICK_EVENT_CA_DOWNLOAD_CGV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRACK_CLICK_EVENT_CA_DOWNLOAD_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_ESF_WIDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return TRACK_CLICK_EVENT_CA_TRAVEL_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TRACK_CLICK_EVENT_CA_MENU_FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TRACK_CLICK_EVENT_CA_MENU_MEMBERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TRACK_CLICK_EVENT_CA_MENU_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TRACK_CLICK_EVENT_CA_MENU_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TRACK_CLICK_EVENT_CA_MENU_SECURITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TRACK_CLICK_EVENT_CA_MENU_SPONSORSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TRACK_CLICK_EVENT_CA_MENU_STAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TRACK_CLICK_EVENT_CA_MENU_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TRACK_CLICK_EVENT_CA_MENU_VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TRACK_CLICK_EVENT_CA_OPTION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TRACK_CLICK_EVENT_CA_OPTION_CONFIRM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TRACK_CLICK_EVENT_CA_OPTION_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TRACK_CLICK_EVENT_CA_OPTION_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TRACK_CLICK_EVENT_CA_PROFILE_COMPANIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TRACK_CLICK_EVENT_CA_PROFILE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return TRACK_CLICK_EVENT_CA_PROFILE_PASSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TRACK_CLICK_EVENT_CA_PROFILE_COMPANION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return TRACK_CLICK_EVENT_CA_PROFILE_INFO_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return TRACK_CLICK_EVENT_CA_PROFILE_PASSPORT_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return TRACK_CLICK_EVENT_CA_PROFILE_PASSPORT_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return TRACK_CLICK_EVENT_CA_PUSH_CRUISES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return TRACK_CLICK_EVENT_CA_PUSH_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return TRACK_CLICK_EVENT_CA_PUSH_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TRACK_CLICK_EVENT_CA_PUSH_TOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return TRACK_CLICK_EVENT_CA_SIMULATOR_RECALCULATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ob", function() { return TRACK_SUBMIT_EVENT_CA_SPONSORSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return TRACK_CLICK_EVENT_CA_STAYS_ANCHOR_FUTUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return TRACK_CLICK_EVENT_CA_STAYS_ANCHOR_PAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return TRACK_CLICK_EVENT_CA_STAYS_ANCHOR_CANCELED; });
/* unused harmony export TRACK_CLICK_EVENT_CA_STAY_ADD_TRANSPORT */
/* unused harmony export TRACK_CLICK_EVENT_CA_OPTION_STAY_ADD_TRANSPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRACK_CLICK_EVENT_CA_CHECK_PASSPORT_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACK_CLICK_EVENT_CA_CHECK_PASSPORT_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRACK_CLICK_EVENT_CA_COMPLETE_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return TRACK_CLICK_EVENT_CA_STAY_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_FREQUENT_QUESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_DISCOVER_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TRACK_CLICK_EVENT_CA_PAST_TRIP_BOOK_AGAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TRACK_CLICK_EVENT_CA_OPTION_DETAILS_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TRACK_CLICK_EVENT_CA_OPTION_DETAILS_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_PEACEOFMIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TRACK_CLICK_EVENT_CA_OPTION_DETAILS_MYFLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_MYFLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_MYSERVICES_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return TRACK_CLICK_EVENT_CA_STAY_PRODUCT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TRACK_CLICK_EVENT_CA_OPTION_STAY_PRODUCT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return TRACK_CLICK_EVENT_CA_STAY_PRODUCT_FACTSHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TRACK_CLICK_EVENT_CA_OPTION_STAY_PRODUCT_FACTSHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACK_CLICK_EVENT_CA_BOOKING_CONTACT_PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return TRACK_CLICK_EVENT_CA_STAY_PAYMENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TRACK_CLICK_EVENT_CA_SERVICE_EASYARRIVAL_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TRACK_CLICK_EVENT_CA_SERVICE_EASYARRIVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return TRACK_CLICK_EVENT_CA_TOAST_EASYARRIVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return TRACK_CLICK_EVENT_CA_STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TRACK_CLICK_EVENT_CA_OPTION_STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return TRACK_CLICK_EVENT_CA_STAFF_SEEMORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return TRACK_CLICK_EVENT_CA_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TRACK_CLICK_EVENT_CA_PAYMENT_FREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TRACK_CLICK_EVENT_CA_PAYMENT_FREE_BOOKING_DETAILS; });
/* unused harmony export TRACK_CLICK_EVENT_CA_EASYCHECKIN */
/* unused harmony export TRACK_SUCCESS_EVENT_CA_EASYCHECKIN */
/* unused harmony export TRACK_FAILURE_EVENT_CA_EASYCHECKIN */
/* unused harmony export TRACK_SUCCESS_EVENT_CA_EASYCHECKOUT_ACTIVATION */
/* unused harmony export TRACK_SUCCESS_EVENT_CA_EASYCHECKOUT_DESACTIVATION */
/* unused harmony export TRACK_FAILURE_EVENT_CA_EASYCHECKOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return TRACK_CLICK_EVENT_CA_UPSELL_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return TRACK_CLICK_EVENT_CA_UPSELL_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_PYR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return TRACK_CLICK_EVENT_CA_UPSELL_RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_CHILDCARES_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_ESF_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_INSURANCES_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_PACKAGES_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_PYR_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_RENTALS_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return TRACK_CLICK_EVENT_CA_UPSELL_TRANSFERS_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return TRACK_CLICK_EVENT_CA_UPSELL_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return TRACK_CLICK_EVENT_CA_SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TRACK_CLICK_EVENT_CA_FINISH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return TRACK_CLICK_EVENT_CA_TOAST_VOUCHERS; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("829J");
/* harmony import */ var _events_trackings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Gh9m");









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



/* PAGELOAD */

var TRACK_PAGELOAD_EVENT_CA_CHILDCARES = {
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: 'ple_upsellChildcare',
  siteType: 'B2B'
};
var TRACK_PAGELOAD_EVENT_CA_ESF = {
  categoryGA: 'ple-homepage',
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: 'ple_esf'
};
var TRACK_PAGELOAD_EVENT_CA_ESF_RESULT = {
  categoryGA: 'ple-homepage',
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"]
};
var TRACK_PAGELOAD_ERROR_EVENT_CA_ESF = _objectSpread(_objectSpread({}, TRACK_PAGELOAD_EVENT_CA_ESF_RESULT), {}, {
  pageName: 'ple_esf_payment_error'
});
var TRACK_PAGELOAD_SUCCESS_EVENT_CA_ESF = _objectSpread(_objectSpread({}, TRACK_PAGELOAD_EVENT_CA_ESF_RESULT), {}, {
  pageName: 'ple_esf_payment_confirmation'
});
var TRACK_PAGELOAD_EVENT_CA_INSURANCES = {
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: 'ple_insurance',
  siteType: 'B2B'
};
var TRACK_PAGELOAD_EVENT_CA_PROFILE = {
  BE_customerStatus: '{BE_CUSTOMER_STATUS}',
  categoryGA: 'ple-profile',
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: '{LOGIN_TYPE}_profile_page',
  siteSection: '{LOGIN_TYPE}'
};
var TRACK_PAGELOAD_EVENT_CA_RENTALS = {
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: 'ple_skiEquipment',
  siteType: 'B2B'
};
var TRACK_PAGELOAD_EVENT_CA_TEAM = {
  BE_customerStatus: '{BE_CUSTOMER_STATUS}',
  categoryGA: 'ple-go-team',
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: 'ple_go_team_page'
};
var TRACK_PAGELOAD_EVENT_CA_TRANSFERS = {
  event: _constants__WEBPACK_IMPORTED_MODULE_8__[/* VIRTUAL_PAGE_LOAD */ "w"],
  pageName: 'ple_upsellTransfer',
  siteType: 'B2B'
};
/* ----- FRAGS ----- */

var TRACK_FRAG_CA_INFOBANNER = {
  actionGA: 'bannerInfo',
  labelGA: 'clickBannerInfo',
  versionBooking: 'responsive'
};
var TRACK_FRAG_CA_MENU = {
  categoryGA: '{LOGIN_TYPE}',
  labelGA: '{PAGE_ID}'
};
var TRACK_FRAG_CA_PROFILE = {
  actionGA: 'MyProfile',
  categoryGA: '{LOGIN_TYPE}'
};
var TRACK_FRAG_CA_PUSH = {
  actionGA: 'push_content',
  categoryGA: '{LOGIN_TYPE}'
};
var TRACK_FRAG_CA_STAY_CTA = {
  actionGA: 'CTA_service',
  categoryGA: '{LOGIN_TYPE}'
};
var TRACK_FRAG_CA_STAY_DETAILS_CTA = {
  actionGA: 'MyTripDetails',
  categoryGA: '{LOGIN_TYPE}'
};
var TRACK_FRAG_CA_OPTION_DETAILS_CTA = {
  actionGA: 'OptionDetails',
  categoryGA: '{LOGIN_TYPE}'
};

var TRACK_FRAG_CA_UPSELL_CTA = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_CTA), {}, {
  versionBooking: 'responsive'
});

var TRACK_FRAG_CA_TRIPS = {
  actionGA: 'MyTrips',
  categoryGA: '{LOGIN_TYPE}'
};
/* ----- ACTIONS ----- */

var TRACK_CLICK_EVENT_CA_FEEDBACK = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'CTA_evaluateMyStay'
});
var TRACK_CLICK_EVENT_CA_PREBOOKING_ACCESS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_access_prebookingForm'
});
/* DOCS */

var TRACK_CLICK_EVENT_CA_DOWNLOAD_CGV = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'DownloadCGV'
});
var TRACK_CLICK_EVENT_CA_DOWNLOAD_CONTRACT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'DownloadContract'
});
/* ESF */

var TRACK_CLICK_EVENT_CA_UPSELL_ESF_WIDGET = {
  actionGA: 'esf',
  labelGA: 'continue_layer'
};
/* TRAVEL PLANS */

var TRACK_CLICK_EVENT_CA_TRAVEL_PLAN = {
  categoryGA: '{LOGIN_TYPE}',
  actionGA: 'CTA_finalise_my_booking',
  labelGA: 'ple_travel_plans_page'
};
/* MENU */

var TRACK_CLICK_EVENT_CA_MENU_FAQ = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_ple_assistance'
});
var TRACK_CLICK_EVENT_CA_MENU_MEMBERSHIP = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_gm_program_info_prospect'
});
var TRACK_CLICK_EVENT_CA_MENU_PROFILE = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_modify_profile'
});
var TRACK_CLICK_EVENT_CA_MENU_SEARCHES = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_myTravelPlans'
});
var TRACK_CLICK_EVENT_CA_MENU_SECURITY = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_modify_password'
});
var TRACK_CLICK_EVENT_CA_MENU_SPONSORSHIP = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_mySponsorship'
});
var TRACK_CLICK_EVENT_CA_MENU_STAYS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_myStays'
});
var TRACK_CLICK_EVENT_CA_MENU_SUBSCRIPTION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_mySubscription'
});
var TRACK_CLICK_EVENT_CA_MENU_VOUCHERS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_myVouchers'
});
/* OPTION */

var TRACK_CLICK_EVENT_CA_OPTION_DETAILS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_detail_option'
});
var TRACK_CLICK_EVENT_CA_OPTION_CONFIRM = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_confirm_option'
});
var TRACK_CLICK_EVENT_CA_OPTION_PAYMENT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_pay_to_confirm_option'
});
var TRACK_CLICK_EVENT_CA_OPTION_PRODUCT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_discoverResort_option'
});
/* PROFILE */

var TRACK_CLICK_EVENT_CA_PROFILE_COMPANIONS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  labelGA: 'tab_MyTravelCompanions'
});
var TRACK_CLICK_EVENT_CA_PROFILE_INFO = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  labelGA: 'tab_MyInformation'
});
var TRACK_CLICK_EVENT_CA_PROFILE_PASSPORT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  labelGA: 'tab_MyPassport'
});
var TRACK_CLICK_EVENT_CA_PROFILE_COMPANION_EDIT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  labelGA: 'edit_myTravelCompanions'
});
var TRACK_CLICK_EVENT_CA_PROFILE_INFO_EDIT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  labelGA: 'edit_myInformation'
});
var TRACK_CLICK_EVENT_CA_PROFILE_PASSPORT_EDIT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  labelGA: 'edit_myPassport'
});
var TRACK_CLICK_EVENT_CA_PROFILE_PASSPORT_SUBMIT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PROFILE), {}, {
  actionGA: 'CTA_save_passport_info',
  labelGA: 'ple_profile_page'
});
/* PUSH */

var TRACK_CLICK_EVENT_CA_PUSH_CRUISES = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PUSH), {}, {
  labelGA: 'Cruises'
});
var TRACK_CLICK_EVENT_CA_PUSH_DESTINATIONS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PUSH), {}, {
  labelGA: 'Destinations'
});
var TRACK_CLICK_EVENT_CA_PUSH_OFFERS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PUSH), {}, {
  labelGA: 'Offers'
});
var TRACK_CLICK_EVENT_CA_PUSH_TOURS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_PUSH), {}, {
  labelGA: 'Tours'
});
/* SIMULATOR */

var TRACK_CLICK_EVENT_CA_SIMULATOR_RECALCULATE = {
  actionGA: 'CTA_replay_point_simulator',
  categoryGA: '{LOGIN_TYPE}'
};
/* SPONSORSHIP */

var TRACK_SUBMIT_EVENT_CA_SPONSORSHIP = {
  actionGA: 'CTA_send_recommandation_form',
  labelGA: 'SponsorshipProgram'
};
/* STAYS */

var TRACK_CLICK_EVENT_CA_STAYS_ANCHOR_FUTUR = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'tab_Futur'
});
var TRACK_CLICK_EVENT_CA_STAYS_ANCHOR_PAST = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'tab_Past'
});
var TRACK_CLICK_EVENT_CA_STAYS_ANCHOR_CANCELED = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'tab_Canceled'
});
/* STAY */

var TRACK_CLICK_EVENT_CA_STAY_ADD_TRANSPORT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'CTA_wantTransport'
});
var TRACK_CLICK_EVENT_CA_OPTION_STAY_ADD_TRANSPORT = _objectSpread(_objectSpread({}, TRACK_CLICK_EVENT_CA_STAY_ADD_TRANSPORT), TRACK_FRAG_CA_OPTION_DETAILS_CTA);
var TRACK_CLICK_EVENT_CA_CHECK_PASSPORT_STAY = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'CheckPassportInformation'
});
var TRACK_CLICK_EVENT_CA_CHECK_PASSPORT_OPTION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_OPTION_DETAILS_CTA), {}, {
  labelGA: 'CheckPassportInformation'
});
var TRACK_CLICK_EVENT_CA_COMPLETE_PAYMENT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_complete_payment'
});
var TRACK_CLICK_EVENT_CA_STAY_DETAILS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'CTA_details_of_my_trip'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_FREQUENT_QUESTIONS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'Link_FrequentQuestions'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_DISCOVER_RESORT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'ResortDetails.Dashboard'
});
var TRACK_CLICK_EVENT_CA_PAST_TRIP_BOOK_AGAIN = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'CTA_bookAgain'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_SUMMARY = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'tab_Summary'
});
var TRACK_CLICK_EVENT_CA_OPTION_DETAILS_SUMMARY = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_OPTION_DETAILS_CTA), {}, {
  labelGA: 'MyOptionDetails'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_ACCOMMODATION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'tab_MyRoom'
});
var TRACK_CLICK_EVENT_CA_OPTION_DETAILS_ACCOMMODATION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_OPTION_DETAILS_CTA), {}, {
  labelGA: 'MyRoom'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_PEACEOFMIND = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'tab_PeaceOfMind'
});
var TRACK_CLICK_EVENT_CA_OPTION_DETAILS_MYFLIGHT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_OPTION_DETAILS_CTA), {}, {
  labelGA: 'MyFlight'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_MYFLIGHT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'tab_MyFlight'
});
var TRACK_CLICK_EVENT_CA_PRODUCT_DETAILS_MYSERVICES_ACTIVITIES = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'tab_MyServicesActivities'
});
var TRACK_CLICK_EVENT_CA_STAY_PRODUCT_DETAILS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'ResortDetails.Dashboard'
});
var TRACK_CLICK_EVENT_CA_OPTION_STAY_PRODUCT_DETAILS = _objectSpread(_objectSpread({}, TRACK_CLICK_EVENT_CA_STAY_PRODUCT_DETAILS), TRACK_FRAG_CA_OPTION_DETAILS_CTA);
var TRACK_CLICK_EVENT_CA_STAY_PRODUCT_FACTSHEET = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'CTA_download_factsheet'
});
var TRACK_CLICK_EVENT_CA_OPTION_STAY_PRODUCT_FACTSHEET = _objectSpread(_objectSpread({}, TRACK_CLICK_EVENT_CA_STAY_PRODUCT_FACTSHEET), TRACK_FRAG_CA_OPTION_DETAILS_CTA);
var TRACK_CLICK_EVENT_CA_BOOKING_CONTACT_PHONE = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'clickToCall'
});
var TRACK_CLICK_EVENT_CA_STAY_PAYMENT_DETAILS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'seePaymentDetails'
});
/* STAY ARRIVAL */

var TRACK_CLICK_EVENT_CA_SERVICE_EASYARRIVAL_SECTION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_TRIPS), {}, {
  labelGA: 'logoEasyArrival',
  versionBooking: 'responsive'
});
var TRACK_CLICK_EVENT_CA_SERVICE_EASYARRIVAL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_easy_arrival'
});
var TRACK_CLICK_EVENT_CA_TOAST_EASYARRIVAL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'easyArrival_toaster'
});
/* STAY STAFF */

var TRACK_CLICK_EVENT_CA_STAFF = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  labelGA: 'seeAllGO'
});
var TRACK_CLICK_EVENT_CA_OPTION_STAFF = _objectSpread(_objectSpread({}, TRACK_CLICK_EVENT_CA_STAFF), TRACK_FRAG_CA_OPTION_DETAILS_CTA);
var TRACK_CLICK_EVENT_CA_STAFF_SEEMORE = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  actionGA: 'optionDetails',
  labelGA: 'seeMore_CDV'
});
/* PAYMENT */

var TRACK_CLICK_EVENT_CA_PAYMENT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  actionGA: 'CTA_pay_my_balance',
  labelGA: '{LOGIN_TYPE}_booking_details'
});
var TRACK_CLICK_EVENT_CA_PAYMENT_FREE = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_STAY_DETAILS_CTA), {}, {
  actionGA: 'CTA_pay_split_payment'
});
var TRACK_CLICK_EVENT_CA_PAYMENT_FREE_BOOKING_DETAILS = _objectSpread(_objectSpread({}, TRACK_CLICK_EVENT_CA_PAYMENT_FREE), {}, {
  labelGA: '{LOGIN_TYPE}_booking_details'
});
/* SERVICES */

var TRACK_CLICK_EVENT_CA_EASYCHECKIN = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_register_my_credit_card',
  labelGA: 'ple_prepare_my_stay_page',
  siteSection: '{LOGIN_TYPE}'
});
var TRACK_SUCCESS_EVENT_CA_EASYCHECKIN = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'checkin_is_successful',
  labelGA: 'ple_prepare_my_stay_page',
  siteSection: '{LOGIN_TYPE}'
});
var TRACK_FAILURE_EVENT_CA_EASYCHECKIN = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'checkin_is_denied',
  labelGA: 'ple_prepare_my_stay_page',
  siteSection: '{LOGIN_TYPE}'
});
var TRACK_SUCCESS_EVENT_CA_EASYCHECKOUT_ACTIVATION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'checkout_activation_is_successful',
  labelGA: 'ple_prepare_my_stay_page',
  siteSection: '{LOGIN_TYPE}'
});
var TRACK_SUCCESS_EVENT_CA_EASYCHECKOUT_DESACTIVATION = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'checkout_activation_is_successful',
  labelGA: 'ple_prepare_my_stay_page',
  siteSection: '{LOGIN_TYPE}'
});
var TRACK_FAILURE_EVENT_CA_EASYCHECKOUT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'checkout_activation_is_denied',
  labelGA: 'ple_prepare_my_stay_page',
  siteSection: '{LOGIN_TYPE}'
});
/* UPSELLS */

var TRACK_CLICK_EVENT_CA_UPSELL_CHILDCARES = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellChildcare.Dashboard'
});
var TRACK_CLICK_EVENT_CA_UPSELL_ESF = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellActivities.esf.Dashboard'
});
var TRACK_CLICK_EVENT_CA_UPSELL_INSURANCES = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellInsurance.Dashboard'
});
var TRACK_CLICK_EVENT_CA_UPSELL_PACKAGES = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellJoyview.Dashboard'
});
var TRACK_CLICK_EVENT_CA_UPSELL_PYR = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'pickYourRoom.Dashboard'
});
var TRACK_CLICK_EVENT_CA_UPSELL_RENTALS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellSkiEquipment.Dashboard'
});
var TRACK_CLICK_EVENT_CA_UPSELL_TRANSFERS = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellTransfer.Dashboard'
});
/* UPSELLS DETAILPAGE */

var TRACK_CLICK_EVENT_CA_UPSELL_CHILDCARES_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellChildcare.detail'
});
var TRACK_CLICK_EVENT_CA_UPSELL_ESF_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellEsf.detail'
});
var TRACK_CLICK_EVENT_CA_UPSELL_INSURANCES_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellInsurance.detail'
});
var TRACK_CLICK_EVENT_CA_UPSELL_PACKAGES_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellJoyview.detail'
});
var TRACK_CLICK_EVENT_CA_UPSELL_PYR_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'pickYourRoom.detail'
});
var TRACK_CLICK_EVENT_CA_UPSELL_RENTALS_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), _events_trackings__WEBPACK_IMPORTED_MODULE_9__[/* TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL */ "a"]);
var TRACK_CLICK_EVENT_CA_UPSELL_TRANSFERS_DETAIL = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'UpsellTransfer.detail'
});
var TRACK_CLICK_EVENT_CA_UPSELL_DASHBOARD = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_UPSELL_CTA), {}, {
  labelGA: 'details.Dashboard'
});
/* LOGIN */

var TRACK_CLICK_EVENT_CA_SIGNOUT = _objectSpread(_objectSpread({}, TRACK_FRAG_CA_MENU), {}, {
  actionGA: 'CTA_disconnectMe'
});
/* PAYMENT */

var TRACK_CLICK_EVENT_CA_FINISH_PAYMENT = {
  actionGA: 'CTA_finishPayment',
  categoryGA: '{LOGIN_TYPE}',
  labelGA: '{LOGIN_TYPE}_prePaymentPage',
  siteSection: '{LOGIN_TYPE}'
};
/* VOUCHERS */

var TRACK_CLICK_EVENT_CA_TOAST_VOUCHERS = {
  actionGA: 'FTC',
  categoryGA: '{LOGIN_TYPE}',
  labelGA: 'displayAmountToaster'
};

/***/ }),

/***/ "gbpH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumb; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("i5Mr");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
      items = _ref.items;
  return items.length > 1 ? __jsx("ul", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('flex reset-list text-14', className)
  }, items.map(function (item, i) {
    return __jsx("li", {
      className: "px-5",
      key: item.label
    }, i < items.length - 1 ? __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      className: "text-darkGrey focus:text-blue hover:text-blue",
      "data-testid": item.dataTestId,
      onClick: item.onClick,
      url: item.url
    }, item.label), __jsx("span", {
      className: "rtl:ml-10"
    }, ">")) : __jsx("span", {
      className: "font-bold text-blue"
    }, item.label));
  })) : null;
};

/***/ })

}]);